"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../../constants");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  boxSizing: 'border-box',
  gridTemplateColumns: `repeat(${_constants.galleryNumberOfElements}, 1fr)`,
  gridTemplateRows: '1fr',
  gap: theme.spacing(_constants.galleryGap),
  alignItems: 'center',
  justifyItems: 'center',
  justifyContent: 'center',
  width: `calc(100vw - ${theme.spacing(_constants.galleryGap * 2)})`,
  margin: '0 auto',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: `repeat(${_constants.gallerySMNumberOfElements}, 1fr)`,
    gap: theme.spacing(_constants.gallerySMGap),
    width: `calc(100vw - ${theme.spacing(_constants.gallerySMGap * 2)})`
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: `repeat(${_constants.galleryMDNumberOfElements}, 1fr)`,
    gap: theme.spacing(_constants.galleryMDGap),
    width: `calc(100vw - ${theme.spacing(_constants.galleryMDGap * 2)})`,
    maxWidth: _constants.galleryMaxWidth
  }
}));
